// REDIRECT_STARTED is shared. The "booking panel state change" action is
// dispatched under different names on each platform (BOOKING_PANEL_STATE_CHANGE
// on Banana, FLIGHTS_BOOKING_PANEL_STATE_CHANGE on Acorn) but carries the same
// {isOpen} payload — the universal reducer matches both literals.
export const REDIRECT_STARTED = 'REDIRECT_STARTED' as const;
export const PQS_PRESENTATION_DELAY_FINISHED = 'PQS_PRESENTATION_DELAY_FINISHED' as const;
export const BANANA_BOOKING_PANEL_STATE_CHANGE = 'BOOKING_PANEL_STATE_CHANGE' as const;
export const ACORN_BOOKING_PANEL_STATE_CHANGE = 'FLIGHTS_BOOKING_PANEL_STATE_CHANGE' as const;

export type BookingPanelStateChangePayload = {
  isOpen: boolean;
};

export type BookingPanelStateChangeAction = {
  type: typeof BANANA_BOOKING_PANEL_STATE_CHANGE | typeof ACORN_BOOKING_PANEL_STATE_CHANGE;
  payload: BookingPanelStateChangePayload;
};
